import * as EventConstants from 'constants/EventConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';
import * as SidebarConstants from './SidebarConstants';

class SidebarStore extends Store {
  resetState() {
    this.isOpen = true;
    this.section = SidebarConstants.Section.BROWSER;
  }

  getIsOpen() {
    return this.isOpen;
  }

  getSection() {
    return this.section;
  }

  payloadHandler(action) {
    let newIsOpen;
    let newSection;
    switch (action.actionType) {
      case EventConstants.SIDEBAR_OPEN:
        this.isOpen = true;
        if (action.section != null) {
          this.section = action.section;
        }
        this.emitChange();
        break;

      case EventConstants.SIDEBAR_CLOSE:
        this.isOpen = false;
        this.emitChange();
        break;

      case EventConstants.SIDEBAR_OPEN_FOR_FILE_TYPE: {
        const {fileType} = action;
        // Template fileTypes should always show the NOTEBOOK_SETTINGS_TEMPLATE section open.
        if (fileType === ModelTypeConstants.TEMPLATE) {
          newSection = SidebarConstants.Section.NOTEBOOK_SETTINGS_TEMPLATE;
          newIsOpen = true;
          // For non-template fileTypes, the section should be one of the standard sections
          // (BROWSER/WORKSPACE/SEARCH). If an invalid section is open, default to the BROWSER section.
        } else if (!SidebarConstants.STANDARD_SECTIONS.includes(this.section)) {
          newSection = SidebarConstants.Section.BROWSER;
          newIsOpen = this.isOpen;
          // Otherwise, we do not need to change the section.
        } else {
          newSection = this.section;
          newIsOpen = this.isOpen;
        }

        if (newSection !== this.section || newIsOpen !== this.isOpen) {
          this.section = newSection;
          this.isOpen = newIsOpen;
          this.emitChange();
        }
        break;
      }

      default:
        break;
    }

    return true;
  }
}

export default new SidebarStore(AppDispatcher);
